import { useMutation } from '@tanstack/react-query';

import { CashFlowApi } from '../cashFlow.api';

export const useGetLiabilitiesCalculation = () => {
  return useMutation({
    mutationFn: CashFlowApi.getLiabilitiesCalculation,
  });
};
